import { List, Skeleton } from "antd";
import React from "react";
import { genArray } from "Explore/Utils/ArrayGenerator";
import styles from "./Loading.module.scss";
const LoadingListCard = ({
  isLoading,
  grid,
  backgroundImage,
  component,
  componentNum,
  rows = 2,
  avatar = true,
}) => {
  const LoadingCard = ({ rows, imageUrl, avatar }) => {
    return (
      <div
        className={styles["loading-card"]}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        <Skeleton
          avatar={avatar}
          paragraph={{
            rows: rows,
          }}
          active
        />
      </div>
    );
  };
  return isLoading ? (
    <List
      grid={grid}
      dataSource={genArray(componentNum)}
      renderItem={(index) => {
        return (
          <List.Item key={index}>
            <LoadingCard
              rows={rows}
              imageUrl={backgroundImage}
              avatar={avatar}
            />
          </List.Item>
        );
      }}
    />
  ) : (
    component
  );
};

export default LoadingListCard;
